import React, {createContext, Dispatch, SetStateAction, useContext, useState} from 'react';
import {AlertTypes, ModalActions} from '../../enums/api';

interface IModalContext {
  modalContext: IModalData;
  setModalContext: Dispatch<SetStateAction<IModalData>>;
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
}

interface IModalData {
  buttonText: string;
  btnAction: ModalActions | null;
  type: AlertTypes;
  displayMessage: string;
  title: string;
  message: string;
}

const initialState = {
  buttonText: '',
  btnAction: null,
  type: AlertTypes.INFO,
  displayMessage: '',
  title: '',
  message: ''
};

//create context to save data for modal after request type filters value

const ModalContext = createContext<IModalContext>({
  modalContext: initialState,
  setModalContext: () => {},
  isOpen: false,
  setIsOpen: () => {}
});

export const ModalContextProvider: React.FC<{children: React.ReactNode}> = ({children}) => {
  const [modalContext, setModalContext] = useState<IModalData>(initialState);
  const [isOpen, setIsOpen] = useState(false);
  return (
    <ModalContext.Provider value={{modalContext, setModalContext, isOpen, setIsOpen}}>{children}</ModalContext.Provider>
  );
};

//hook to get/set device type filters value

export const useModalContext = () => {
  const context = useContext(ModalContext);

  if (!context) {
    throw new Error('useModalContext must be used within useContextProvider');
  }

  return context;
};
